import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const CurrentUserModule = {
  namespaced: true,
  state: {
    //- The logged in user
    current_user: {},
    notifications: []
  },
  getters,
  actions,
  mutations
}

export default CurrentUserModule